module.exports = __webpack_public_path__ + "img/img_19_brand_retail@3x.408d6cf1.png";